import { DOMAIN_URL } from './DomainConfig';

export const PATH_ROOT = DOMAIN_URL;
export const PATH_USER_UPLOADS = PATH_ROOT + "user_uploads";
export const PATH_USER_UPLOADS_USER = PATH_USER_UPLOADS + "/user/{userId}";
export const PATH_USER_UPLOADS_COMPANY = PATH_USER_UPLOADS + "/company/{companyId}";
export const PATH_USER_UPLOADS_COMPANY_LOGO = PATH_USER_UPLOADS_COMPANY + "/logo/";
export const PATH_USER_UPLOADS_COMPANY_BANNER = PATH_USER_UPLOADS_COMPANY + "/banner/";
export const PATH_USER_UPLOADS_COMPANY_SIGNATURES = PATH_USER_UPLOADS_COMPANY + "/signatures/";


// Caminhos para APIs de assinatura
export const PATH_SUBSCRIPTION_API = PATH_ROOT + "api/subscription";
export const PATH_SUBSCRIPTION_COMPANY_API = PATH_SUBSCRIPTION_API + "/company";
export const PATH_SUBSCRIPTION_UPDATE_PLAN_API = PATH_SUBSCRIPTION_COMPANY_API + "/update_plan.php";
export const PATH_SUBSCRIPTION_SIMULATE_PLAN_CHANGE_API = PATH_SUBSCRIPTION_COMPANY_API + "/simulate_plan_change.php";
export const PATH_SUBSCRIPTION_HISTORY_API = PATH_SUBSCRIPTION_COMPANY_API + "/history.php";

const RemotePath = {
    PATH_ROOT: () => PATH_ROOT,
    PATH_USER_UPLOADS: () => PATH_USER_UPLOADS,
    PATH_USER_UPLOADS_USER: (userId) => PATH_USER_UPLOADS_USER.replace("{userId}", userId),
    PATH_USER_UPLOADS_USER_PICTURE: (userId) => PATH_USER_UPLOADS_USER.replace("{userId}", userId),
    PATH_USER_UPLOADS_COMPANY: (companyId) => PATH_USER_UPLOADS_COMPANY.replace("{companyId}", companyId),
    PATH_USER_UPLOADS_COMPANY_LOGO: (companyId) => PATH_USER_UPLOADS_COMPANY_LOGO.replace("{companyId}", companyId),
    PATH_USER_UPLOADS_COMPANY_BANNER: (companyId) => PATH_USER_UPLOADS_COMPANY_BANNER.replace("{companyId}", companyId),
    PATH_USER_UPLOADS_COMPANY_RESOURCE_SIGNATURE: (companyId) => PATH_USER_UPLOADS_COMPANY_SIGNATURES.replace("{companyId}", companyId),
    
    // Assinaturas
    PATH_SUBSCRIPTION_UPDATE_PLAN: PATH_SUBSCRIPTION_UPDATE_PLAN_API,
    PATH_SUBSCRIPTION_SIMULATE_PLAN_CHANGE: PATH_SUBSCRIPTION_SIMULATE_PLAN_CHANGE_API,
    PATH_SUBSCRIPTION_HISTORY: PATH_SUBSCRIPTION_HISTORY_API,
}

export default RemotePath;